import { useTranslation } from 'react-i18next'
import { BET_TYPES_AUTO_GENERATE_BET_NUMBER, FUNCTION_MENU } from './constants'
import { BetTypeEnum } from '@/ui-components/components/BetLotto/BetLotto.types'
import type { BetType } from './types'
import useBetControl from '../useBetControl'
import { useLottoConfig } from './useLottoConfig'

export interface BetTypeItems {
  key: BetType
  label: string
  digit: number
  onClick?: () => void
}

const getDigit = (type: string): number => {
  const digitMap: { [key: string]: number } = {
    betTwo: 2,
    betThree: 3,
    betOne: 1,
    betSix: 6,
    betFour: 4,
  }
  return digitMap[type] || NaN
}

export const useRenderItem = (
  selectedBetTypes: string[],
  addLottoListAndHandleResponse: ReturnType<
    typeof useBetControl
  >['addLottoListAndHandleResponse'],
) => {
  const { t } = useTranslation()
  const { lottoConfig } = useLottoConfig()

  const initBetItem = (): BetTypeItems[] => {
    const betItemDataArray: BetTypeItems[] = []

    Object.entries(lottoConfig).forEach(([digitType, digitConfig]) => {
      Object.entries(digitConfig).forEach(([key, value]) => {
        if (!['bet_four', 'bet_six'].includes(key)) {
          const betItem: BetTypeItems = {
            label: t(`betDetailPanel.betLottoType.${key}`) + `  (${value})`,
            key: key as BetTypeEnum,
            digit: getDigit(digitType),
          }
          betItemDataArray.push(betItem)
        }
      })
    })
    return betItemDataArray
  }

  const functionMenu: BetTypeItems[] = FUNCTION_MENU.map((item) => ({
    key: item.key,
    label: t(`betDetailPanel.betLottoType.${item.key}`),
    digit: item.digit,
  }))

  const initBet = [...initBetItem(), ...functionMenu]

  const injectFunctionLottoBet = (
    data: BetTypeItems[],
    selected: string[],
  ): BetTypeItems[] => {
    const buildOnClickFunction = (numbers: string[]) => {
      // TODO: find way to remove `as BetTypeEnum[]`
      numbers.forEach((number) => {
        addLottoListAndHandleResponse(number, selected as BetTypeEnum[])
      })
    }

    return data?.map((v) => {
      // TODO: We should move this logic to handleSelectBetType
      const handler = BET_TYPES_AUTO_GENERATE_BET_NUMBER[v.key]
      if (handler) {
        v.onClick = () => {
          const numbers = handler()
          buildOnClickFunction(numbers)
        }
      }

      return v
    })
  }

  const renderItem = injectFunctionLottoBet(initBet, selectedBetTypes)

  return {
    renderItem,
  }
}
